export default "__VITE_PUBLIC_ASSET__302c20d2__"